import { Icon } from "components"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { getStartDate } from "modules/Payment/common/utils"
import { PriceContainer } from "modules/Payment/FormPage/components/PriceContainer"
import { getSingleOrFamilyText } from "modules/BookingCommon/common/utils"
import { OnlineOrOfflineLabel } from "modules/BookingCommon/components"
import { renderCityWithDetails } from "utils/helpers/psychologistUtil"

export function SessionInfoMobileCard() {
    const [{ isOnline, serviceGroup, bookingDetails }] = usePaymentContext()

    return (
        <div className="booking-form__session-info-mobile">
            <div className="booking-form__session-info-mobile__top">
                <div className="booking-form__session-info-mobile-headline">
                    Информация о&nbsp;сессии
                </div>
                <div className="booking-form__session-info-mobile-family-or-single-person">
                    <OnlineOrOfflineLabel online={isOnline} />
                    <span className="booking-form__session-info-mobile-bullet">•</span>
                    {getSingleOrFamilyText(!serviceGroup?.family)}
                </div>
                <>
                    <div className="session-date-time__session-info-date">
                        {getStartDate(bookingDetails.rfc3339_start_datetime)}
                    </div>
                </>
                {!isOnline && (
                    <div className="session-date__session-info-location">
                        <Icon
                            type="nav"
                            color="blue-3"
                            size={24}
                            className="session-date__session-info-location__icon"
                        />
                        {renderCityWithDetails(
                            bookingDetails.psy.new_city.name,
                            bookingDetails.psy.city_details
                        )}
                    </div>
                )}
            </div>
            <PriceContainer
                className="booking-form__session-info-mobile__price-container"
                innerClassName="booking-form__session-info-mobile__price"
            />
        </div>
    )
}
